var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "similar-product product-slider" },
    [
      _c("h2", { staticClass: "product-slider__title section-title" }, [
        _vm._v("\n    Аксессуары\n  "),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          class: [
            "filters-wrapper",
            { "_with-background": _vm.showBackground },
          ],
        },
        [
          _c("filtersList", {
            ref: "filtersList",
            staticClass: "filters-list",
            on: {
              "change-filter": _vm.changeFilterHandler,
              "show-background": function ($event) {
                _vm.showBackground = true
              },
              "hide-background": function ($event) {
                _vm.showBackground = false
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("productSlider", {
        staticClass: "product-slider",
        attrs: {
          "products-list": _vm.activeProductsList,
          discount: _vm.userDiscount,
        },
        on: { slideChange: _vm.changeSlideHandler },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }